import { ContactInitSettingModalComponent } from './contact-init-setting-modal.component';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { OrganizationComboBoxModule } from '@blcloud/bl-ng-share-module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ContactInitDisplaySettingResource, ContactExecuteItemResource } from '@blcloud/bl-ng-resource';

@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CollapseModule,
    OrganizationComboBoxModule.forRoot(),
  ],
  exports: [
    ContactInitSettingModalComponent,
  ],
  declarations: [
    ContactInitSettingModalComponent,
  ],
  entryComponents: [
    ContactInitSettingModalComponent,
  ],
  providers: [
    ContactInitDisplaySettingResource,
    ContactExecuteItemResource,
  ]
})
export class ContactInitSettingModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ContactInitSettingModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/contact-init-setting/contact-init-setting-modal.module.ts